// extracted by css-extract-rspack-plugin
export default {"Text":"iteration-diff-value-module__Text__QN0mS","Text_1":"iteration-diff-value-module__Text_1__h5ByL","Text_2":"iteration-diff-value-module__Text_2__KuZGO"};